import { AriaRole, useId } from "react";
import cx from "classnames";

import useTypedContext from "hooks/useTypedContext";
import { ThemeContext } from "views/Theme";
import { BoxProps } from "ds/components/Box";
import { withTestId } from "utils/withTestId";

import styles from "./styles.module.css";
import CardWrapper from "../../components/Wrapper";
import { CardCollapsibleContext } from "./Context";
import { CardSize } from "../../types";

type CardCollapsibleWrapperProps = {
  variant?: "secondary" | "primary";
  size?: CardSize;
  withTransition?: boolean;
  role?: AriaRole;
  ref?: React.ForwardedRef<HTMLDivElement>;
  isCollapsed: boolean;
  onToggle: () => void;
  "data-testid"?: string;
} & Pick<BoxProps, "children" | "className">;

const CardCollapsibleWrapper = ({
  children,
  variant,
  size,
  isCollapsed,
  onToggle,
  role,
  className,
  ref,
  "data-testid": dataTestId,
}: CardCollapsibleWrapperProps) => {
  const contentId = useId();

  const { reducedMotion } = useTypedContext(ThemeContext);

  return (
    <CardCollapsibleContext.Provider value={{ isCollapsed, onToggle, contentId }}>
      <CardWrapper
        direction="column"
        fullWidth
        variant={variant}
        size={size}
        role={role}
        className={cx(styles.collapsibleWrapper, className, {
          [styles.withTransition]: !reducedMotion,
          [styles.isCollapsed]: isCollapsed,
        })}
        ref={ref}
        {...withTestId(dataTestId)}
      >
        {children}
      </CardWrapper>
    </CardCollapsibleContext.Provider>
  );
};

CardCollapsibleWrapper.displayName = "DS.Card.Collapsible.Wrapper";

export default CardCollapsibleWrapper;
